import { render, staticRenderFns } from "./optionals-widget.vue?vue&type=template&id=86889d0a&scoped=true"
import script from "./optionals-widget.vue?vue&type=script&lang=js"
export * from "./optionals-widget.vue?vue&type=script&lang=js"
import style0 from "./optionals-widget.vue?vue&type=style&index=0&id=86889d0a&prod&lang=scss&scoped=true"
import style1 from "./optionals-widget.vue?vue&type=style&index=1&id=86889d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86889d0a",
  null
  
)

export default component.exports